import { connect } from "react-redux";
import { Dispatch } from "redux";
import { mp_addTab } from "../../../../redux/reducers/MembersPortalReducer";
import IAppState from "../../../../redux/types/IAppState";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { MemberStatementWorksPage } from "./MemberStatementWorksPage";
import { IMemberStatementWorkState } from "../../../../redux/types/IMemberStatementState";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";

export default connect(
    (state: IAppState): {
        workDetailGridsComponentData: IMembersPortalComponentDataItem;
        workPageComponentData: IMembersPortalComponentDataItem;
        userNameNumber: string;
        memberStatementWorkState: IMemberStatementWorkState
    } => ({
        workDetailGridsComponentData: state.membersPortal.componentData.MemberStatementWorkDetailsGridsView,
        workPageComponentData: state.membersPortal.componentData.MemberStatementWorksPage,
        userNameNumber: state.account.currentUserNameNumber,
        memberStatementWorkState: state.membersPortal.tabs[state.membersPortal.activeTab].memberStatementWorkState
    }),
    (dispatch: Dispatch) => ({
        addTab: (tab: ITabReduxItem) => dispatch(mp_addTab(tab)),
    })
)(MemberStatementWorksPage);
